import Typography from '@/components/shared/typography/typography.component';
import Image, { StaticImageData } from 'next/image';

export const HelpSectionDesc = ({
    image,
    title,
    desc,
}: {
    image: StaticImageData;
    title: string;
    desc: string;
}) => {
    return (
        <div className="flex flex-col items-center md:flex-row md:gap-x-3">
            <Image
                src={image}
                alt="car badge"
                className="en:transform en:scale-x-[-1]"
            />
            <div className="md:flex md:flex-col justify-center text-center md:text-start">
                <Typography className="text-gray-800 text-subtitle2SemiBold">
                    {title}
                </Typography>
                <Typography className="text-gray-600 text-caption">
                    {desc}
                </Typography>
            </div>
        </div>
    );
};
